import React, { FC } from "react";
import "./BackgroundPage.scss";

interface IBackgroundPage {
  position?: "fixed" | "absolute";
}

const BackgroundPage: FC<IBackgroundPage> = ({ position = "fixed" }) => {
  return (
    <div
      className="container__background__page"
      style={{
        position,
      }}
    />
  );
};

export default BackgroundPage;
